export default "__VITE_ASSET__DDR_vPM4__"